<template>
  <div class="promoter-list" ref="container">
    <div class="header">
      <div class="promoterHeader bg-color-red" style="background-color: #efd094 !important;height:4rem;">
        <div class="headerCon acea-row row-between-wrapper" >
          <div style="margin-top:-2rem;">
            <div class="name">注册记录</div>
           <!--<div>
              <span class="num" style="font-size:0.3rem;">{{ first }}</span>人
            </div>-->

          </div >
          <div class="iconfont icon-tuandui" style="margin-top:-2rem;"></div>
        </div>
      </div>
      <div style="height: 1.2rem;
    margin: -1.7rem auto 0px;
    width: 7rem;
    background-color: rgb(74, 62, 44);
    border-radius: 0.2rem 0.2rem 0px 0px;
        color: rgb(227, 213, 174);">
            <span class="num" style="height:1.1rem;font-size:0.3rem;width:50%;display:block;float:left;text-align:center;padding:0.1rem 0rem;" >
              <span style="height: 1rem;
    line-height: 1rem;
    text-align: left;
    display: block;
    margin-left: 0.4rem;">总数：{{first}}人</span>

            </span>

        <span style="clear:both;"></span>
      </div>
      <div style="background-color:#fff;width:7.2rem;margin:0 auto;border-radius: 0.06rem;display: flex;flex-wrap: wrap" v-if="levelCountCount">
          <span class="num" style="height:1.1rem;border:1px solid #f1f1f1;font-size:0.3rem;width:33.33333%;display:block;text-align:center;padding:0.1rem 0rem;" v-for="(item, index) in levelCount" :key="index">
            <span style="height:0.1rem;display:block;">{{index}}</span><br />{{item}}人
          </span>
        <span style="clear:both;"></span>
      </div>
      <div class="search acea-row row-between-wrapper" style="margin-top:0.2rem;">
        <form @submit.prevent="submitForm">
          <div class="input">
            <input placeholder="会员号/手机号" v-model="screen.keyword" />
            <span class="iconfont icon-guanbi"></span>
          </div>
        </form>
        <div class="iconfont icon-sousuo2" @click="submitForm"></div>
      </div>
    </div>
    <div class="list">

      <div :class="fixedState === true ? 'sortList' : ''">
        <div
                class="item acea-row row-between-wrapper"
                v-for="(val, index) in spreadList"
                :key="index"
        >
          <div class="picTxt acea-row row-between-wrapper" style="width: 6.4rem;">
            <div class="pictrue"><img :src="val.avatar" /></div>
            <div class="text" style="width:5.04rem">
              <div class="name line1">
                <span style="font-size: 0.3rem;line-height: 0.6rem;">{{ val.level_name }}等级</span>
                <span v-if="val.level==1"  @click="delUser(val.uid)" style="float:right;color:#fff;background-color:#733831;padding:0.1rem;border-radius: 0.1rem;margin-left:0.1rem;" class="bonus_show">注销账号</span>
<!--                v-if="val.level<5"-->
                <router-link   :to="{ path: '/hot_new_goods/5/'+val.account }" style="float:right;color:#fff;background-color:#733831;padding:0.1rem;border-radius: 0.1rem;" class="bonus_show">升级/复购</router-link>
                <router-link v-if="val.is_lock_bonus==1"  :to="{ path: '/user/register/'+val.account }" style="margin-right:0.2rem;float:right;color:#fff;background-color:#733831;padding:0.1rem;border-radius: 0.1rem;" class="bonus_show">复投（{{ val.is_lock_bonus_level_name }}）</router-link>
              </div>
              <div class="name line1">
                <span style="font-size: 0.3rem;line-height: 0.6rem;">{{ val.account }} {{ val.nickname }}</span>
              </div>
              <div class="name line1">
                <span style="font-size: 0.3rem;line-height: 0.6rem;">推荐：{{ val.spread_uid_account }} {{ val.spread_uid_nickname }}</span>
              </div>
              <!--<div class="name line1">{{ val.phone }}</div>-->
              <!--<div class="name line1">直推：{{ val.spread_count }}人</div>
              <div class="name line1">团队：{{ val.spread_all }}人</div>-->
              <div> {{ val.add_time }}</div>


            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading :loaded="loaded" :loading="loading"></Loading>
  </div>
</template>
<style>
  .promoter-list .list .item{
    height:auto;
    padding-bottom:0.2rem;
    padding-top:0.2rem;
  }
  .show_layer {
    text-align: center;
    border: 1px solid #f1f1f1;
    margin-top: 0.2rem;
    line-height: 0.6rem;
    color: #999;
    font-size: 0.2rem;
    width:50%;
    float:left;
  }
  .can_show_layer {
    color:#000;
  }
</style>
<script>
  import { userRegisterList,lock_bonus,cancelDelHandle} from "../../api/user";
  import Loading from "@components/Loading";
  import dialog from "@utils/dialog";
  export default {
    name: "UserRegisterList",
    components: {
      Loading
    },
    props: {},
    data: function() {
      return {
        fixedState: false,
        screen: {
          page: 1,
          limit: 15,
          keyword: "",
          sort: ""
        },
        childCount: 2,
        numberCount: 2,
        orderCount: 2,
        loaded: false,
        loading: false,
        spreadList: [],
        levelCount:[],
        levelCountCount:0,
        allCount:0,
        loadTitle: "",
        first: "",
        second: ""
      };
    },
    mounted: function() {
      this.userRegisterList();
      this.$scroll(this.$refs.container, () => {
        !this.loading && this.userRegisterList();
      });
    },


    methods: {
      handleScroll: function() {
        var scrollTop =
                document.documentElement.scrollTop || document.body.scrollTop;
        var offsetTop = document.querySelector(".header").clientHeight;
        if (scrollTop >= offsetTop) {
          this.fixedState = true;
        } else {
          this.fixedState = false;
        }
      },
      delUser(uid) {
        let that = this;
        cancelDelHandle(uid).then(res => {
          that.$dialog.success(res.msg).then(() => {
            location.reload();
          });
        })
                .catch(err => {
                  this.$dialog.error(err.msg);
                });
      },
      submitForm: function() {
        this.screen.page = 0;
        this.loaded = false;
        this.loading = false;
        this.spreadList = [];
        this.userRegisterList();
      },

      userRegisterList: function() {
        let that = this,
                screen = that.screen;
        if (that.loaded || that.loading) return;
        that.loading = true;
        userRegisterList(screen).then(
                res => {
                  that.loading = false;
                  that.spreadList.push.apply(that.spreadList, res.data.list);
                  that.levelCount = res.data.levelCount;
                  that.levelCountCount = res.data.levelCountCount;
                  that.loaded = res.data.list.length < that.screen.limit; //判断所有数据是否加载完成；
                  that.loadTitle = that.loaded ? "人家是有底线的" : "上拉加载更多";
                  that.screen.page = that.screen.page + 1;
                  that.first = res.data.total;
                },
                error => {
                  that.$dialog.message(error.msg);
                },
                300
        );
      },

    }
  };
</script>
